import React from "react";
import { Container, Nav, Navbar } from "react-bootstrap";
import { useAuthState } from "react-firebase-hooks/auth";
import { Link } from "react-router-dom";
import auth from "../../../firebase.init";
import { signOut } from "firebase/auth";
import logo from "../../../images/logo.jpg";
import "./Header.css";
const Header = () => {
  const [user] = useAuthState(auth);

  const handleSignOut = () => {
    signOut(auth);
  };
  return (
    <>
      <>
        <Navbar bg="light" variant="light">
          <Container>
            <Navbar.Brand to="#home">
              <img src={logo} height="50" alt="" />{" "}
            </Navbar.Brand>
            <Nav className="me-auto">
              <Link to="/home">Home</Link>
              <Link to="/items">Items</Link>
              <Link to="/inventory/inventoryId">Inventory</Link>
              <Link to="/blogs">Blogs</Link>
              <Link to="/about">About</Link>
              {user ? (
                <button onClick={handleSignOut}>SignOut</button>
              ) : (
                <Link to="/login">Login</Link>
              )}
              <Link to="/register">Register</Link>
            </Nav>
          </Container>
        </Navbar>
      </>
    </>
  );
};

export default Header;
